import { Marked } from "marked";

export const STATUSER = [
  { k: "inbox", label: "Ny", dot: "#98A2B3" },
  { k: "doing", label: "Pågår", dot: "#0EA5E9" },
  { k: "waiting", label: "Venter", dot: "#F59E0B" },
  { k: "done", label: "Ferdig", dot: "#10B981" },
];
export const STATUS_LABEL = Object.fromEntries(STATUSER.map((s) => [s.k, s.label]));
export const STATUS_DOT = Object.fromEntries(STATUSER.map((s) => [s.k, s.dot]));

export const PRIORITETER = [
  { v: 1, label: "P1 · Kritisk", kort: "P1", farge: "#DC2626", bg: "#FEF2F2" },
  { v: 2, label: "P2 · Normal", kort: "P2", farge: "#6B7280", bg: "#F5F5F4" },
  { v: 3, label: "P3 · Lav", kort: "P3", farge: "#9CA3AF", bg: "#FAFAF9" },
];
export const PRI = Object.fromEntries(PRIORITETER.map((p) => [p.v, p]));

export function initialer(navn) {
  return String(navn || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((d) => d[0])
    .join("")
    .toUpperCase();
}

export function medlem(members, id) {
  return (members || []).find((m) => m.id === id) || null;
}

export function fristInfo(due, today) {
  if (!due) return null;
  const d = new Date(`${due}T12:00:00`);
  const t = new Date(`${today || new Date().toISOString().slice(0, 10)}T12:00:00`);
  const diff = Math.round((d - t) / 86400000);
  const kort = d.toLocaleDateString("nb-NO", { day: "numeric", month: "short" });
  if (diff < 0) return { label: `${Math.abs(diff)} d over`, tone: "over", kort };
  if (diff === 0) return { label: "I dag", tone: "idag", kort };
  if (diff === 1) return { label: "I morgen", tone: "snart", kort };
  return { label: kort, tone: "ok", kort };
}

export const FRIST_KLASSE = {
  over: "text-red-600 bg-red-50",
  idag: "text-amber-700 bg-amber-50",
  snart: "text-neutral-600 bg-neutral-100",
  ok: "text-neutral-500 bg-neutral-100",
};

export function datoOm(dager) {
  const d = new Date();
  d.setDate(d.getDate() + dager);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

export function fmtBytes(n) {
  if (n == null) return "";
  if (n >= 1048576) return `${(n / 1048576).toFixed(1).replace(".", ",")} MB`;
  if (n >= 1024) return `${Math.round(n / 1024)} kB`;
  return `${n} B`;
}

export function vedleggKategori(att) {
  const n = String(att?.name || "").toLowerCase();
  const ct = String(att?.contentType || "");
  if (ct.startsWith("image/")) return "bilde";
  if (ct === "application/pdf" || n.endsWith(".pdf")) return "pdf";
  if (n.endsWith(".docx") || n.endsWith(".doc")) return "word";
  if (n.endsWith(".xlsx") || n.endsWith(".xls") || n.endsWith(".csv")) return "regneark";
  if (n.endsWith(".txt") || n.endsWith(".md") || n.endsWith(".json") || n.endsWith(".log")) return "tekst";
  return "fil";
}

export function fmtTid(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("nb-NO", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function sorterSaker(a, b) {
  if ((a.priority || 2) !== (b.priority || 2)) return (a.priority || 2) - (b.priority || 2);
  if (a.dueDate !== b.dueDate) {
    if (!a.dueDate) return 1;
    if (!b.dueDate) return -1;
    return a.dueDate < b.dueDate ? -1 : 1;
  }
  return (b.updatedAt || "") < (a.updatedAt || "") ? -1 : 1;
}

const md = new Marked({ gfm: true, breaks: true, async: false });
const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function renderRik(kilde, navn = []) {
  let src = String(kilde || "").trim();
  if (!src) return "";
  src = src.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  let html = "";
  try {
    html = md.parse(src);
  } catch (e) {
    return `<p>${esc(kilde)}</p>`;
  }
  html = html.replace(/<a href="([^"]*)"[^>]*>/gi, (m, href) =>
    /^(https?:|mailto:)/i.test(String(href).trim())
      ? `<a href="${href}" target="_blank" rel="noopener noreferrer">`
      : "<a>"
  );
  for (const n of navn) {
    if (!n) continue;
    const trygg = esc(n);
    const re = new RegExp(`@${trygg.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`, "g");
    html = html.replace(re, `<span class="rik-mention">@${trygg}</span>`);
  }
  return html;
}
